import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Config } from '@shared/configs/config';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { BasePanelService } from '@modules/base-panel/pages/base-panel/services/base-panel.service';
import { foundRouteDataHelper } from '@shared/helpers/found-route-data.helper';

@Component({
  selector: 'df-base-header',
  templateUrl: './base-header.component.html',
  styleUrls: ['./base-header.component.scss'],
})
export class BaseHeaderComponent implements AfterViewInit {
  Config = Config;

  headerComponent;
  inited = false;

  @ViewChild('container', { read: ViewContainerRef })
  container!: ViewContainerRef;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private resolver: ComponentFactoryResolver,
    private changes: ChangeDetectorRef,
    public basePanelService: BasePanelService,
  ) {
    this.setRouterListener();
  }

  back() {
    window.history.back();
  }

  ngAfterViewInit() {
    this.inited = true;
    this.setHeaderComponent();
  }

  setRouterListener() {
    this.foundHeaderDataInRouteSnapshot();
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.route),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        mergeMap((route) => route.data),
      )
      .subscribe((routeData) => {
        this.detectHeader(routeData);
      });
  }

  foundHeaderDataInRouteSnapshot(): void {
    const data = foundRouteDataHelper('headerComponent', this.route.snapshot);
    if (data) {
      this.detectHeader(data);
    }
  }

  detectHeader(routeData) {
    if (routeData.headerComponent && routeData.headerComponent !== this.headerComponent) {
      this.headerComponent = routeData.headerComponent;
      this.setHeaderComponent();
    } else if (!routeData.headerComponent) {
      this.clearContainer();
    }
  }

  clearContainer() {
    this.headerComponent = null;
    this.container ? this.container.clear() : '';
  }

  setHeaderComponent() {
    if (!this.inited || !this.headerComponent) return;
    this.container.clear();
    const factory = this.resolver.resolveComponentFactory(this.headerComponent);
    this.container.createComponent(factory);
    this.changes.detectChanges();
  }
}
